(function () {
  'use strict';

  angular
    .module('app.category', ['infinite-scroll'])

    /* @ngInject */
    .factory('InfiniteScrollApi', ["$location", "CategoryService", "CategoryCacheService", function ($location, CategoryService, CategoryCacheService) {
      var api = function () {
        this.items = [];
        this.busy = false;
        this.page = 1;
        this.facets = [];
        this.search = '';
      };

      api.prototype.nextPage = function () {
        if ($location.path().indexOf('-c-') === -1) return;

        var _this = this;
        if (this.maxPage === 0) return;
        if (this.busy || this.page === this.maxPage) return;
        if (this.filtered && !this.filteredActive) return;

        this.busy = true;
        CategoryService.getProducts(++this.page, this.filtered, this.sort, this.facets, this.brands, this.reviews, this.types, this.prices, this.search, this.idCategory, this.nbPerPage)
          .then(function (data) {
            if (data) {
              _this.items = _this.items.concat(data.products);
              CategoryCacheService.set($location.url(), _this.page, _this.items);
              _this.busy = false;
            }
          })
          .catch(function (error) {
            console.error(error);
          });
      };

      api.prototype.nextSearchPage = function () {
        var path = $location.path();

        var _this = this;
        if (this.busy || this.page === this.maxPage) return;

        this.busy = true;
        var search = $location.search().q || path.slice(path.lastIndexOf('/') + 1);
        CategoryService.getProducts(++this.page, false, '', null, null, null, null, null, search)
          .then(function (data) {
            _this.items = _this.items.concat(data.products);
            _this.busy = false;
          })
          .catch(function (error) {
            console.error(error);
          });
      };

      return api;
    }])

    /* @ngInject */
    .directive('categoryProducts', function () {
      return {
        restrict: 'A',
        scope: true,
        bindToController: {
          idCategory: '<',
          totalProducts: '<',
          nbPerPage: '<',
          maxPage: '<',
          sort: '@',
          sortTitle: '@',
          device: '<'
        },
        controllerAs: 'categoryCtrl',
        /* @ngInject */
        controller: ["$scope", "$element", "$rootScope", "$document", "$timeout", "$location", "InfiniteScrollApi", "productsGridService", "CategoryCacheService", "CategoryService", "RoutingService", function ($scope, $element, $rootScope, $document, $timeout, $location, InfiniteScrollApi, productsGridService, CategoryCacheService, CategoryService, RoutingService) {
          var ctrl = this,
            loadCache;

          CategoryService.setGridCtrl(ctrl);

          ctrl.$onInit = function () {
            if (window.isBot || window.isCache) {
              ctrl.nbProducts = ctrl.totalProducts;
              return;
            }
            ctrl.api = new InfiniteScrollApi(ctrl.currentPage);

            var locSearch = {};
            _.each($location.search(), function (value, key) {
              if (key.indexOf('f') === 0) {
                locSearch[key] = value;
              }
            });
            ctrl.api.filtered = !_.isEmpty(locSearch);

            ctrl.api.idCategory = ctrl.idCategory;
            ctrl.api.nbPerPage = ctrl.nbPerPage;
            ctrl.api.maxPage = ctrl.maxPage;
            ctrl.api.sort = ctrl.sort || '';

            var cache = CategoryCacheService.get($location.url());
            if (cache) {
              loadCache = true;
              $timeout(function () {
                $rootScope.$broadcast('showPageLoader', true);
              });
              ctrl.api.page = cache[0];
              ctrl.api.items = cache[1];
            }

            if (!ctrl.api.filtered) {
              ctrl.nbProducts = ctrl.totalProducts;
            }
          };
          ctrl.$onDestroy = function () {
            ctrl.api.busy = true;
          };

          $element.find('.onload').removeClass('hidden');

          ctrl.loaded = function (reload) {
            reload = reload || false;
            $timeout(function () {
              productsGridService.resizeGrid('productsGrid', ctrl.device.size, !reload);
              $rootScope.$emit('lazyImg:refresh');
              if (loadCache) {
                loadCache = false;
                setTimeout(RoutingService.windowScroll, 100);
                $timeout(function () {
                  $rootScope.$broadcast('showPageLoader', false);
                });
              }
            });
          };

          ctrl.openDropdown = function (event) {
            var $button = $(event.currentTarget),
              $menu = $button.siblings('.dropdown-menu');
            if ($button.parent().hasClass('open')) {
              $menu.removeAttr('style');
            } else if (ctrl.device.xxs) {
              $menu.css({
                left: $button.offset().left * -1 + 10,
                width: $(document.body).width() - 20
              });

              var closeDropdown = function () {
                $menu.removeAttr('style');
                $document.off('click', closeDropdown);
              };

              $timeout(function () {
                $document.on('click', closeDropdown);
              }, 500);
            }
          };

          ctrl.setSort = function (event, value) {
            event.preventDefault();

            ctrl.sort = value;
            ctrl.sortTitle = event.target.innerText;

            var path = $location.path(),
              cut = path.lastIndexOf('/') !== 0 ? path.slice(0, path.lastIndexOf('/')) : path,
              url = value !== '' ? cut + '/' + value : cut;

            $location.path(url);
          };

        }]
      };

    });

  angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 250);

})();
